<script lang="ts">
	import PageHead from '$lib/components/common/PageHead.svelte';
	// import RenderArticleCards from '$lib/components/blog/article/RenderArticleCards.svelte';
	import RenderCardsUnderPost from './RenderCardsUnderPost.svelte';
	// export let rows = 1;
	let page = 0;
	let pageSize = 6;
	// eslint-disable-next-line no-unused-vars
	let visible = false;

	import { onMount } from 'svelte';
	import { filterStore } from '$lib/components/blog/filter/filter.store';
	import { handleAlert } from '$lib/components/alert';

	import { getPublishedPostsRandom, posts } from '$lib/posts';

	async function loadPosts() {
		try {
			// let _data: any;
			let _error: any;
			// own posts only
			// if ($filterStore.owner.toLowerCase() == 'mine') {
			// 	// must be logged in
			// 	if (browser && !$user) {
			// 		handleAlert({ type: 'warning', text: 'Please log in to view your posts.' });
			// 		$filterStore.owner = 'all';
			// 	} else {
			// 		// get posts matching my user id
			// 		const { data, error } = await getMyPosts();
			// 		$posts = data;

			// 		// handle errors
			// 		if (error) handleAlert({ type: 'error', text: error.message });
			// 	}
			// } else {
			// get all posts
			await getPublishedPostsRandom(page, pageSize);
			// $posts = data;
			page += 1;
			// _data = $posts;

			// handle err
			if (_error) handleAlert({ type: 'error', text: _error.message });

			// no filters case
			// if ($filterStore.topics.toLowerCase() == 'all') {
			// 	$posts = data;
			// } else {
			// 	// make sure we have data
			// 	if (data) {
			// 		// apply topics filter
			// 		$posts = data.filter((tpost) => {
			// 			return tpost.topic.toLowerCase().includes($filterStore.topics.toLowerCase());
			// 		});
			// 	}
			// }
		} catch (error) {
			handleAlert({ type: 'error', text: error.message });
		}
	}

	const reloadPosts = () => {
		visible = false;
		page = 0;
		$posts.length = 0;
		// don't display posts until done loading
		loadPosts().then(() => (visible = true));
	};

	// Load posts on component mount
	onMount(() => {
		reloadPosts();
	});

	// reload posts on filter event
	$: if ($filterStore.rerender) {
		page = 0;
		$posts.length = 0;
		reloadPosts();
	}
</script>

<PageHead title="Home" description="Bloom Network" />

<!-- TODO: on tablet up show a horizontal slider, 6 posts total
mobile, needs margin at top and label - more adventures
 -->
<h2
	class="mt-5 lg:mt-8
 md:mb-0 lg:mb-3 py-6 mx-3
 text-xl lg:text-2xl gradient-green font-black font-exo-2 text-center"
>
	More Adventures
</h2>

<div class="font-exo-2 max-w-screen-3xl mx-auto">
	<!-- {JSON.stringify($posts)} -->

	<RenderCardsUnderPost posts={$posts} />

	<slot />
</div>
